import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import '../../../../Assets/css/educationCenter.css'
import LooseDimondImg from '../../../../Assets/images/diamond-education/loos-d.jpg'
import GemstoneImg from '../../../../Assets/images/diamond-education/gemstone.jpg'
import EngagmentRingImg from '../../../../Assets/images/diamond-education/eng-r.jpg'
import WeddingRingImg from '../../../../Assets/images/diamond-education/wed-r.jpg'
import FineJeweleryImg from '../../../../Assets/images/diamond-education/fine-j.jpg'
import Slider from 'react-slick'
// import "~slick-carousel/slick/slick.css";
// import "~slick-carousel/slick/slick-theme.css";
import '../../../../../node_modules/slick-carousel/slick/slick.css'
import '../../../../../node_modules/slick-carousel/slick/slick-theme.css'
import { useHistory } from 'react-router-dom'

const EducationCenter = () => {
    const history = useHistory()

    const settingsEducationCenter = {
        dots: true,
        infinite: true,
        autoPlay: true,
        autoplaySpeed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false

    };
    return (
        <div className='dd_eduction_center_page'>
            <Container className='dd_educontainer'>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div className='dd_eduction_title'>
                            <h1 className='text-uppercase text-center'>EDUCATION CENTER</h1>
                        </div>
                    </Col>
                </Row>
                {/* desktop view of education center */}
                <Row className='w-100 m-auto dd_education_center_desktop_view'>
                    <Col sm={12} md={12} lg={12}>
                        <ul className='p-0 dd_education_center_ul_box'>
                            <li>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/loosediamonds') }} >
                                    <div className='dd_edu_center_heading'>
                                        <h2>LOOSE DIAMONDS</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={LooseDimondImg} alt="Loose Diamond Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">LOOSE DIAMONDS</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            {/* <li>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/gemstones') }} >
                                    <div className='dd_edu_center_heading'>
                                        <h2>GEMSTONES</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={GemstoneImg} alt="Gemstone Diamond Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">GEMSTONES</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li> */}
                            <li>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/engagment-ring') }}>
                                    <div className='dd_edu_center_heading'>
                                        <h2>ENGAGEMENT RINGS</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={EngagmentRingImg} alt="Engagment Ring Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">ENGAGEMENT RINGS</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/wedding-ring') }} >
                                    <div className='dd_edu_center_heading'>
                                        <h2>WEDDING RINGS</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={WeddingRingImg} alt="Wedding Ring Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">WEDDING RINGS</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/fine-jewelery') }}>
                                    <div className='dd_edu_center_heading'>
                                        <h2>FINE JEWELRY</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={FineJeweleryImg} alt="Fine Jewelery Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">FINE JEWELRY</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                    </Col>
                    {/* <Col sm={12} md={2} lg={2}>
                        <div className='dd_eduction_box_outer'>
                            <div className='dd_edu_center_heading'>
                                <h2>LOOSE DIAMONDS</h2>
                            </div>
                            <div>
                                <Image src={GemstoneImg} alt="Loose Diamond Image" className='img-fluid' />
                            </div>
                        </div>
                    </Col> */}
                </Row>
                {/* desktop view of education center */}


                {/* Mobile view of education center start */}
                <Row>
                    <div className='dd_education_center_mobile_view'>
                        <Slider {...settingsEducationCenter}>
                            <div>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/loosediamonds') }}>
                                    <div className='dd_edu_center_heading'>
                                        <h2>LOOSE DIAMONDS</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={LooseDimondImg} alt="Loose Diamond Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">LOOSE DIAMONDS</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/gemstones') }}>
                                    <div className='dd_edu_center_heading'>
                                        <h2>GEMSTONES</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={GemstoneImg} alt="Gemstone Diamond Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">GEMSTONES</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/engagment-ring') }}>
                                    <div className='dd_edu_center_heading'>
                                        <h2>ENGAGEMENT RINGS</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={EngagmentRingImg} alt="Engagment Ring Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">ENGAGEMENT RINGS</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/wedding-ring') }}>
                                    <div className='dd_edu_center_heading'>
                                        <h2>WEDDING RINGS</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={WeddingRingImg} alt="Wedding Ring Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">WEDDING RINGS</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='dd_eduction_box_outer' onClick={() => { history.push('/education/fine-jewelery') }}>
                                    <div className='dd_edu_center_heading'>
                                        <h2>FINE JEWELRY</h2>
                                    </div>
                                    <div className='dd_edu_center_img_box'>
                                        <div className='inner-box'>
                                            <Image src={FineJeweleryImg} alt="Fine Jewelery Image" className='img-fluid' />
                                            <div className="overlay-box">
                                                <div className="overlay-inner">
                                                    <div className="title">FINE JEWELRY</div>
                                                    <h3>READ MORE</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </Slider>
                    </div>

                </Row>
                {/* Mobile view of education center end */}
            </Container>
        </div>
    )
}

export default EducationCenter